import React, { useState, useEffect } from "react";
import Layout from "../../layout/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./style.module.css";
import AdminGrid from "../../components/adminGrid/adminGrid";
import WarningModal from "./components/warningModal";
import { Tag } from "antd";

import {
  getWarningTeachersListing,
  getWarningTeachersContent,
  getWarningStudentsListing,
  getWarningStudentsContent,
} from "../../services/auth";
import toast from "react-hot-toast";
import deleteIcon from "../../assets/images/delete-icon.png";
import { baseUrl } from "../../services/api";
import userIcon from "../../assets/images/user-icon-removebg.png";
import { Rating } from "react-simple-star-rating";
import { format } from "date-fns";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { getStudents, getTeachers } from "../../services/auth";
import { getAllWarnings } from "../../services";

function Notifications() {
  const [showDetailedCardTeacher, setShowDetailedCardTeacher] = useState(false);
  const [showDetailedCardStudent, setShowDetailedCardStudent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rowDataTeacher, setRowDataTeacher] = useState([]);
  const [rowDatastudent, setRowDataStudent] = useState([]);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [cardData, setCardData] = useState({});
  const [cardDataStudent, setCardDataStudent] = useState({});
  const [loadingCard, setLoadingCard] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [students, setStudents] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [warnings, setWarnings] = useState([]);

  const location = useLocation();

  // Fetch students and teachers first
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const [studentRes, teacherRes] = await Promise.all([
          getStudents(),
          getTeachers(),
        ]);

        setStudents(studentRes?.data?.data || []);
        setTeachers(teacherRes?.data?.data || []);
      } catch (error) {
        console.error("Error fetching users:", error);
        toast.error("Failed to fetch students or teachers");
      }
    };

    fetchUsers();
  }, []);

  // Once students and teachers are loaded, fetch warnings
  useEffect(() => {
    if (students.length > 0 && teachers.length > 0) {
      fetchWarnings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [students, teachers]);

  const fetchWarnings = async () => {
    try {
      setLoading(true);
      const warningData = await getAllWarnings();

      // Enrich student warnings
      const studentWarnings = warningData
        .filter((warning) => warning.role === "students")
        .map((warning) => {
          const matchedStudent = students.find(
            (student) => student.id === warning.receiverId
          );
          return {
            ...warning,
            ...matchedStudent,
            default: "testUser",
          };
        });

      // Enrich teacher warnings
      const teacherWarnings = warningData
        .filter((warning) => warning.role === "teachers")
        .map((warning) => {
          const matchedTeacher = teachers.find(
            (teacher) => teacher.id === warning.receiverId
          );
          return {
            ...warning,
            ...matchedTeacher,
            default: "testUser",
          };
        });

      setRowDataStudent(studentWarnings);
      setRowDataTeacher(teacherWarnings);
      setWarnings(warningData);
    } catch (err) {
      toast.error("Failed to fetch warnings: " + err.message);
    } finally {
      setLoading(false);
    }
  };
  const navigate = useNavigate();

  const navigateTo = (path) => {
    navigate(`/notifications/${path}`);
  };

  const currentSection =
    location.pathname.split("/").pop().toLowerCase() ||
    location.pathname.split("/")[2];

  const CustomButton = ({ onClick, label }) => (
    <button
      className="btn btn-primary btn_contained btn-sm fs_12"
      onClick={onClick}
    >
      {label}
    </button>
  );

  const viewCellRendererTeachers = ({ value, data }) => (
    <CustomButton
      label={value === "View" ? "View" : "View"}
      onClick={async () => {
        setDetailsLoading(true);
        try {
          const cardDataTeacher = await getWarningTeachersContent(data?.id);
          setCardData({
            ...data,
            warnings: cardDataTeacher?.data?.data
              ? cardDataTeacher?.data?.data
              : [],
          });
          setShowDetailedCardTeacher(true);
        } catch (error) {
          console.error("Error fetching teacher details:", error);
          toast.error("Failed to load teacher details.");
        } finally {
          setDetailsLoading(false);
        }
        console.log("card data", cardData);
      }}
    />
  );

  const viewCellRendererStudents = ({ value, data }) => (
    <CustomButton
      label={value === "View" ? "View" : "View"}
      onClick={async () => {
        setLoadingCard(true);
        try {
          if (!data.id) {
            console.log("Student ID is undefined or null");
            return;
          }
          const response = await getWarningStudentsContent(data?.id);
          if (response.status === 200) {
            console.log(
              "Student Warning details fetched successfully:",
              response.data
            );
            setCardDataStudent({
              ...data,
              warnings: response?.data?.data ? response?.data?.data : [],
            });
            setShowDetailedCardStudent(true);
          } else {
            console.log("Error fetching student details:", response.statusText);
          }
        } catch (error) {
          console.error("Error fetching student details:", error);
        } finally {
          setLoadingCard(false);
        }
      }}
    />
  );

  const WarningTypeTag = ({ value }) => (
    <Tag
      color="blue"
      bordered={false}
      style={{
        fontSize: "12px",
        margin: "2px",
      }}
    >
      {value || "N/A"}
    </Tag>
  );

  const getRowHeight = (params) => {
    var Heights = [55, 55, 55, 55];
    return Heights[params.node.rowIndex % 4];
  };

  const gridOptions = {
    getRowHeight: getRowHeight,
  };

  const centerStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
  };

  const columnDefsTeachers = [
    {
      headerName: "Teacher",
      field: "fullName",
      flex: 0.3,
      cellStyle: centerStyle,
      filter: true,
    },
    {
      headerName: "Type",
      field: "type",
      flex: 0.3,
      cellRenderer: WarningTypeTag,
      cellStyle: centerStyle,
    },
    {
      headerName: "Description",
      field: "description",
      flex: 1,
      cellStyle: centerStyle,
      filter: true,
    },
  ];

  const columnDefsStudent = [
    {
      headerName: "Student",
      field: "fullName",
      flex: 0.3,
      filter: true,
      cellStyle: centerStyle,
    },
    {
      headerName: "Type",
      field: "type",
      flex: 1,
      cellRenderer: WarningTypeTag,
      cellStyle: centerStyle,
    },
    {
      headerName: "Description",
      field: "description",
      flex: 1,
      filter: true,
      cellStyle: centerStyle,
    },
  ];

  const formatTime = (isoDateString) => {
    if (!isoDateString) return "N/A";
    const date = new Date(isoDateString);
    return format(date, "dd-MM-yyyy - hh:mm a");
  };

  return (
    <Layout>
      {currentSection === "teachers" ? (
        <>
          <div className="d-flex justify-content-between align-items-center px-3">
            <div>
              <h3 className="pageTitle">Notifications</h3>
              <span className="fs_12">Total Number of Teachers</span>
              <span className="fw-bold fs_12">
                {" "}
                "{rowDataTeacher?.length || 0}"
              </span>
            </div>
            <div className=" d-flex align-items-center">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                size="large"
                onClick={() => setIsOpen(true)}
                className="btn btn_contained_black fs_12 btn-sm text-white px-3"
              >
                Create
              </Button>
            </div>
          </div>
          <div className="d-flex justify-content-end px-3">
            <div className="text-right">
              <div
                className="btn-group btn-sm m-0 p-0 text-right"
                role="group"
                aria-label="Basic example"
              >
                <button
                  type="button"
                  onClick={() => {
                    setCardDataStudent(false);
                    setShowDetailedCardTeacher(false);
                    navigateTo("teachers");
                  }}
                  className={`btn btn-sm ${
                    currentSection === "teachers"
                      ? "btn_contained_black text-white"
                      : "btn_outlined text-dark"
                  }`}
                >
                  Teachers
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setShowDetailedCardTeacher(false);
                    setCardData(false);
                    navigateTo("students");
                  }}
                  className={`btn btn-sm ${
                    currentSection === "students"
                      ? "btn_contained_black text-white"
                      : "btn_outlined text-dark"
                  }`}
                >
                  Students
                </button>
              </div>
            </div>
          </div>
        </>
      ) : currentSection === "students" ? (
        <>
          <div className="d-flex justify-content-between align-items-center px-3">
            <div>
              <h3 className="pageTitle">Notifications</h3>
              <span className="fs_12">Total Number of students</span>
              <span className="fw-bold fs_12">
                {" "}
                "{rowDatastudent?.length || 0}"
              </span>
            </div>
            <div>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                size="large"
                onClick={() => setIsOpen(true)}
                className="btn btn_contained_black fs_12 btn-sm text-white px-3"
              >
                Create
              </Button>
            </div>
          </div>
          <div className="d-flex justify-content-end px-3">
            <div className="text-right">
              <div
                className="btn-group btn-sm m-0 p-0"
                role="group"
                aria-label="Basic example"
              >
                <button
                  type="button"
                  onClick={() => {
                    setCardDataStudent(false);
                    setShowDetailedCardStudent(false);
                    navigateTo("teachers");
                  }}
                  className={`btn btn-sm ${
                    currentSection === "teachers"
                      ? "btn_contained_black text-white"
                      : "btn_outlined text-dark"
                  }`}
                >
                  Teachers
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setCardData(false);
                    setShowDetailedCardTeacher(false);
                    navigateTo("students");
                  }}
                  className={`btn btn-sm ${
                    currentSection === "students"
                      ? "btn_contained_black text-white"
                      : "btn_outlined text-dark"
                  }`}
                >
                  Students
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      {/* ShowDetailCardsTeacher */}
      <div className="d-flex justify-content-between">
        <div
          className={`fs_14 pt-1 col-md-${
            showDetailedCardTeacher ? "7" : "12"
          } col-sm-12`}
        >
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "100vh" }}
            >
              <div>Loading...</div>
            </div>
          ) : currentSection === "teachers" ? (
            <AdminGrid
              row={rowDataTeacher}
              cols={columnDefsTeachers}
              rowClass={"fs_12"}
              gridOptions={gridOptions}
              style={{ height: "102%" }}
              pagination={true}
            />
          ) : (
            ""
          )}
        </div>
        {/* TeacherDetailCards */}
        {cardData ? (
          <div
            className={`col-md-5 col-sm-12 pt-3 ${styles.mt_3} ${
              showDetailedCardTeacher ? "" : "d-none"
            }`}
          >
            <span className="fw-bold fs_18">Teacher Detail</span>
            {detailsLoading ? (
              <div className="text-center">
                <div
                  style={{
                    display: "flex",
                    paddingLeft: "30px",
                    alignItems: "start",
                    justifyContent: "center",
                  }}
                >
                  Loading...
                </div>
              </div>
            ) : (
              <div
                className={`mt-3 border border-0 shadow-sm px-4 py-3 rounded-3 text-center ${styles.customBGColor}`}
              >
                <div className="text-right">
                  <img
                    src={deleteIcon}
                    alt="deleteIcon"
                    style={{ width: 20, height: 20, cursor: "pointer" }}
                    onClick={() => {
                      setCardData({});
                      setShowDetailedCardTeacher(false);
                    }}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  {(() => {
                    let hasProfilePicture = false;
                    const profilePicture = cardData?.teacherMedia?.map(
                      (profile) => {
                        if (profile.type === "profilePicture") {
                          hasProfilePicture = true;
                          return (
                            <img
                              key={profile.url} // Ensure each child has a unique key
                              src={
                                profile?.url ? `${baseUrl}${profile?.url}` : ``
                              }
                              alt={`${profile?.fullName}'s profile`}
                              className={`${styles.imgFluid} ${styles.roundedCircle}`}
                            />
                          );
                        }
                        return null;
                      }
                    );

                    return (
                      <>
                        {profilePicture}
                        {!hasProfilePicture && (
                          <img
                            src={userIcon}
                            alt="Default User Icon"
                            className={`${styles.imgFluid} ${styles.roundedCircle}`}
                          />
                        )}
                      </>
                    );
                  })()}
                  <span className="fs_16 fw-bold px-3 py-1 text-center text-sm-start">
                    {cardData?.fullName}{" "}
                    <div className="fs_12 text-secondary py-1">
                      {cardData?.courses && cardData.courses.length > 0 ? (
                        cardData.courses.slice(0, 3).map((course, index) => (
                          <span key={course.id}>
                            {course.courseSubjectName || "N/A"}
                            {index < 2 && ", "}
                          </span>
                        ))
                      ) : (
                        <span>N/A</span>
                      )}
                    </div>
                    <div>
                      <Rating
                        size={20}
                        initialValue={cardData?.rating || 0}
                        readonly={true}
                        style={{ marginRight: "3px", marginTop: "-4px" }}
                      />
                      <span style={{ fontSize: "11px" }}>
                        ({cardData?.ratingCount})
                      </span>
                    </div>
                  </span>
                </div>
                {/* Detailed card content */}
                <hr className="text-secondary" />
                <p className="prodetail text-left fs_16 fw-bold">Warnings</p>
                <div
                  className={`row ${styles.reviews} ${styles.scrollbar_custom}`}
                  style={{ height: "370px", overflowY: "scroll" }}
                >
                  <ul className="text-left">
                    {cardData?.warnings?.map((warning) => (
                      <li className="bg-white shadow-sm list-unstyled rounded fs_14 pr-2 py-2 my-2">
                        <div className="d-flex justify-content-between">
                          <div className="col-6">
                            Message :<br />
                            {warning.content || "N/A"}
                          </div>
                          <div className="col-6 text-right">
                            <span
                              className={`${styles.bg_secondary} text-white px-2 py-1`}
                            >
                              {warning.type || "N/A"}
                            </span>
                          </div>
                        </div>
                        <div className="text-right mt-2 px-2">
                          Date & Time : {formatTime(warning.createdAt || "N/A")}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </div>

      {/* ShowDetailCardsStudent */}
      <div className="d-flex justify-content-between">
        <div
          className={`fs_14 pt-1 col-md-${
            showDetailedCardStudent ? "7" : "12"
          } col-sm-12`}
        >
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "100vh" }}
            >
              <div>Loading...</div>
            </div>
          ) : currentSection === "students" ? (
            <AdminGrid
              row={rowDatastudent}
              cols={columnDefsStudent}
              rowClass={"fs_12"}
              gridOptions={gridOptions}
              style={{ height: "102%" }}
              pagination={true}
            />
          ) : (
            ""
          )}
        </div>
        {/* StudentDetailCards */}
        {cardDataStudent ? (
          <div
            className={`col-md-5 col-sm-12 mt-3 ${styles.mt_3} ${
              showDetailedCardStudent ? "" : "d-none"
            }`}
          >
            <span className="fw-bold fs_18">Student Detail</span>
            {loadingCard ? (
              <div className="text-center">
                <div
                  style={{
                    display: "flex",
                    paddingLeft: "30px",
                    alignItems: "start",
                    justifyContent: "center",
                  }}
                >
                  Loading
                </div>
              </div>
            ) : (
              <div
                className={`mt-3 border border-0 shadow-sm px-4 py-3 rounded-3 text-center ${styles.customBGColor}`}
              >
                <div className="text-right">
                  <img
                    src={deleteIcon}
                    alt="deleteIcon"
                    style={{ width: 20, height: 20, cursor: "pointer" }}
                    onClick={() => {
                      setCardDataStudent({});
                      setShowDetailedCardStudent(false);
                    }}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  {(() => {
                    let hasProfilePicture = false;
                    const profilePicture = cardDataStudent?.teacherMedia?.map(
                      (profile) => {
                        if (profile.type === "profilePicture") {
                          hasProfilePicture = true;
                          return (
                            <img
                              key={profile.url}
                              src={
                                profile?.url ? `${baseUrl}${profile?.url}` : ``
                              }
                              alt={`${profile?.fullName}'s profile`}
                              className={`${styles.imgFluid} ${styles.roundedCircle}`}
                            />
                          );
                        }
                        return null;
                      }
                    );

                    return (
                      <>
                        {profilePicture}
                        {!hasProfilePicture && (
                          <img
                            src={userIcon}
                            alt="Default User Icon"
                            className={`${styles.imgFluid} ${styles.roundedCircle}`}
                          />
                        )}
                      </>
                    );
                  })()}
                  <span className="fs_16 fw-bold px-3 text-center text-sm-start">
                    {cardDataStudent?.fullName || "N/A"}
                    <br />
                    {cardDataStudent?.email || "N/A"}
                  </span>
                  <br />
                </div>
                <hr className="text-secondary" />
                <p className="prodetail text-left fs_16 fw-bold">Warnings</p>
                <div
                  className={`row ${styles.reviews} ${styles.scrollbar_custom}`}
                  style={{ height: "370px", overflowY: "scroll" }}
                >
                  <ul className=" text-left">
                    {cardDataStudent?.warnings?.map((warning) => (
                      <li className="bg-white shadow-sm list-unstyled rounded pr-2 fs_14 py-2 my-2">
                        <div className="d-flex justify-content-between">
                          <div className="col-6">
                            Message :<br />
                            {warning.content || "N/A"}
                          </div>
                          <div className="col-6 text-right pr-2">
                            <span
                              className={`${styles.bg_secondary} text-white px-2 py-1`}
                            >
                              {warning.type || "N/A"}
                            </span>
                          </div>
                        </div>
                        <div className="text-right mt-2 px-2 ">
                          Date & Time : {formatTime(warning.createdAt || "N/A")}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        ) : (
          ""
        )}

        {isOpen ? (
          <WarningModal
            show={isOpen}
            onCancel={() => setIsOpen(false)}
            title={currentSection === "students" ? "student" : "teacher"}
            list={currentSection === "students" ? students : teachers}
            onSubmit={(data) => {
              console.log("Submitted data:", data);
              setIsOpen(false);
              fetchWarnings();
            }}
          />
        ) : null}
      </div>
    </Layout>
  );
}

export default Notifications;
